<template>
    
    <header style=" margin-top: -20px; margin-bottom: 25px; padding-left: 0; padding-right: 0;" id="headerBox" >
                <div class="row w-100 m-0 dd-none blkk" style="  width: 100%;  position: fixed; height: min-content; " >
                    <div class="col blkk" style="padding: 0 !important;">
                        <div class="row w-100 align-items-center justify-content-between position-relative blkk" style="width: 100%; padding-left: 20px; padding-right: 20px;">
                            <div class="col w-auto hp-flex-none hp-mobile-sidebar-button me-24 px-0" data-bs-toggle="offcanvas" data-bs-target="#mobileMenu" aria-controls="mobileMenu">
                                <button type="button" class="btn btn-text btn-icon-only">
                                    <!-- <i class="ri-2x ri-menu-2-line hp-text-color-black-80 hp-text-color-dark-30 lh-1" ></i> -->
                                    <i class="hp-text-color-dark-0 ri-2x ri-menu-2-line" style="font-size: 22px;"></i>
                                </button>
                            </div>

                            <div class="col w-auto hp-flex-none hp-mobile-sidebar-button me-24 px-0" >
                                
                                <img src="@/assets/img/favicon.png" alt="" style="width: 26px; margin-top: 20px;" id="mobileLogo">
                                <h2 style="text-align: center; font-size: 18px; margin-top: 20px;" id="mobileTitle"></h2>
                                
                            </div>

                            <!-- ANNOUNCEMENT -->
                            <!-- <div class="hp-header-text-info col col-lg-14 col-xl-16 hp-header-start-text d-flex align-items-center hp-horizontal-none">
                                <div class="d-flex overflow-hidden rounded-4 hp-bg-color-black-0 hp-bg-color-dark-100" style="min-width: 45px; width: 45px; height: 45px;">
                                    <img src="@/assets/img/newspaper.svg" alt="Newspaper" height="80%" style="margin-top: auto; margin-left: auto;">
                                </div>

                                <p class="hp-header-start-text-item hp-input-label fw-normal hp-text-color-black-100 hp-text-color-dark-0 ms-12 mb-0 lh-1 d-flex align-items-center">
                                    Do you know the latest update of 2022?&nbsp;&nbsp;
                                    <span class="hp-text-color-primary-1">Our roadmap is alive for future updates.</span>
                                </p>
                            </div> -->

                            <div class="col hp-flex-none w-auto pe-0">
                                <div class="row align-items-center justify-content-center">
                                    

                                    <div class="hover-dropdown-fade w-auto px-0 d-flex align-items-center position-relative">
                                        <!-- <button type="button" class="btn btn-icon-only bg-transparen border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-flex align-items-center justify-content-center">
                                            <i class="hp-text-color-dark-0 ri-2x ri-settings-3-line" style="font-size: 24px;"></i>
                                            
                                        </button> -->

                                        <button type="button" class="btn btn-text btn-icon-only" v-if="subPay" @click="goBack">
                                            <i class="hp-text-color-dark-0 ri-2x ri-close-line" style="font-size: 22px;"></i>
                                            
                                        </button>

                                        <button v-else type="button" class="btn btn-text btn-icon-only"  data-bs-toggle="modal" data-bs-target="#settings">
                                            <i class="hp-text-color-dark-0 ri-2x ri-settings-3-line" style="font-size: 22px;"></i>
                                            
                                        </button>

                                        

                                        

                                        
                                    </div>

                                    

                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
    </header>

    <!-- SETTINGS -->
    <div class="modal fade" id="settings" tabindex="-1" aria-labelledby="withdrawLabel" aria-hidden="true" data-bs-backdrop="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border-color: #000; border-width: 2px; border-style: solid;">
                <div class="modal-header">

                    <h3 class="modal-title" style="text-align: center; width: 100%;">Settings</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 10;"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <div class="col-12 col-xl-4 " >

                                    <div class="row g-32 ">

                                        <div class="car hp-card-1" >
                                            <div class="card-body py-16">
                                                <div class="row">
                                                    <div class="col-12 mb-8">
                                                        
                                                        <ul class="me-n1 mx-lg-n12">
                                                            <li class="mt-4 mb-16" id="setProfile3">
                                                                <router-link :to="{name: 'profile'}" class=" position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center" >
                                                                    <i class="iconly-Curved-User me-16 hp-text-color-dark-0" ></i>
                                                                    <span class="hp-text-color-dark-0" >Account Information</span>

                                                                    <span id="setProfile4" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-10" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li class="mt-4 mb-16" id="setSub3">
                                                                <router-link :to="{name: 'sub-bundles'}" class=" position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="hp-text-color-dark-0 iconly-Light-Buy me-16"></i>
                                                                    <span class="hp-text-color-dark-0">Subscription Bundles</span>

                                                                    <span id="setSub4" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-10" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li class="mt-4 mb-16" id="setNoti3" >
                                                                <router-link :to="{name: 'noti-settings'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Curved-Notification me-16 hp-text-color-dark-0 "></i>
                                                                    <span class="hp-text-color-dark-0">Notification Settings</span>

                                                                    <span id="setNoti4" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-10" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li id="setActivity3" class="mt-4 mb-16">
                                                                <router-link :to="{name: 'activity-monitor'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Curved-Activity me-16 hp-text-color-dark-0"></i>
                                                                    <span class="hp-text-color-dark-0">Session Monitor</span>

                                                                    <span id="setActivity4" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-10" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <li class="mt-4 mb-16" id="setSecurity3">
                                                                <router-link :to="{name: 'security-settings'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Curved-Password me-16 hp-text-color-dark-0"></i>
                                                                    <span class="hp-text-color-dark-0">Security Settings</span>

                                                                    <span id="setSecurity4" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-10" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li>

                                                            <!-- <li class="mt-4 mb-16" id="setConnect">
                                                                <router-link :to="{name: 'connect-socials'}" class="position-relative text-black-80 hp-text-color-dark-100 hp-hover-text-color-primary-1 hp-hover-text-color-dark-0 py-12 px-24 d-flex align-items-center">
                                                                    <i class="iconly-Light-AddUser me-16"></i>
                                                                    <span>Connect Socials</span>

                                                                    <span id="setConnect2" class="hp-menu-item-line position-absolute opacity-0 h-100 top-0 end-0 bg-primary hp-bg-dark-0" style="width: 3px;"></span>
                                                                </router-link>
                                                            </li> -->

                                                            
                                                        </ul>

                                                        

                                                    </div>

                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        

                                    </div>

                            </div>


                </div>

                


            </div>
        </div>
    </div>

</template>

<style>
    .blkk{
        background-color: white;
    }

    body.dark .blkk{
        background-color: #141414;
    }

    #headerBox{
        z-index: 0;
    }

    @media only screen and (max-width: 666px){
        #headerBox{
            z-index: 99;
        }

    }

    
</style>

<script>

    export default {

        data(){
            return{
                subPay: false,
            }
        },
        
        mounted(){

            if(this.$route.name == 'profile'){
                document.getElementById('setProfile3').classList.add("setActive");
                document.getElementById('setProfile4').classList.add("opacity-100");

            }
            else if(this.$route.name == 'sub-bundles'){

                document.getElementById('setSub3').classList.add("setActive");
                document.getElementById('setSub4').classList.add("opacity-100");
            }

            else if(this.$route.name == 'noti-settings'){

                document.getElementById('setNoti3').classList.add("setActive");
                document.getElementById('setNoti4').classList.add("opacity-100");
            }

            else if(this.$route.name == 'activity-monitor'){

                document.getElementById('setActivity3').classList.add("setActive");
                document.getElementById('setActivity4').classList.add("opacity-100");
            }

            else if(this.$route.name == 'security-settings'){

                document.getElementById('setSecurity3').classList.add("setActive");
                document.getElementById('setSecurity4').classList.add("opacity-100");
            }

            else if(this.$route.name == 'connect-socials'){

                document.getElementById('setConnect3').classList.add("setActive");
                document.getElementById('setConnect4').classList.add("opacity-100");
            }

            else if(this.$route.name == 'sub-pay'){

                this.subPay = true;
            }

        },

        methods:{
            goBack(){
                this.$router.go(-1);
            },
        }

    }

    

</script>